import type { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

import logo from 'app/assets/icons/sidebar/logo.svg';

import background from './assets/auth-background.webp';
import connectWordmark from './assets/connect-wordmark.svg';

// Shared layout for the guest auth routes (login / forgot-password / password-reset / invitation).
// The background and card live here so they stay mounted while the Outlet swaps forms.
// Fuse's main is h-screen: shrink-0 lets the layout grow past it and my-auto keeps a tall card
// scrolling downwards instead of spilling above the top of the page.
function AuthLayout(): ReactElement {
  return (
    <div className="vtwo:relative vtwo:flex vtwo:min-h-screen vtwo:shrink-0 vtwo:flex-col vtwo:items-center vtwo:bg-black vtwo:px-4 vtwo:py-24 vtwo:font-['Inter_var',sans-serif] vtwo:scheme-dark">
      <img
        alt=""
        src={background}
        className="vtwo:pointer-events-none vtwo:fixed vtwo:inset-0 vtwo:size-full vtwo:object-cover"
      />
      {/* index.html's splash screen draws the same Healthera | Connect lockup */}
      <div className="vtwo:absolute vtwo:top-10 vtwo:left-1/2 vtwo:flex vtwo:w-max vtwo:-translate-x-1/2 vtwo:items-start vtwo:gap-2.5">
        <img alt="Healthera" src={logo} />
        <span className="vtwo:mt-[3px] vtwo:h-3 vtwo:w-px vtwo:bg-white/20" />
        <img alt="Connect" src={connectWordmark} />
      </div>
      <div className="vtwo:relative vtwo:my-auto vtwo:flex vtwo:w-full vtwo:max-w-[440px] vtwo:flex-col vtwo:gap-6 vtwo:rounded-xl vtwo:bg-auth-card vtwo:p-10 vtwo:backdrop-blur-[10px]">
        <Outlet />
      </div>
    </div>
  );
}

export default AuthLayout;
